
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/menu/beer",
      function () {
        return require("private-next-pages/menu/beer.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/menu/beer"])
      });
    }
  